var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFlightTravel64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7568 25.4419L45.266 26.9765C45.6334 27.35 45.7325 27.9113 45.5152 28.3881L43.8461 32.0501L49.276 49.0605C49.702 50.3952 49.2552 52.2693 48.2504 53.2741L47.9296 53.5949C46.9371 54.5874 45.5831 54.3926 44.9099 53.1684L34.0738 33.4609L40.0079 28.7378L43.7568 25.4419Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4374 20.755L35.4561 23.736C35.3741 23.8652 35.2728 23.9939 35.1519 24.1202L29.7415 29.777L10.9324 19.8008C9.70122 19.1479 9.50068 17.8169 10.4877 16.8299L10.8317 16.4859C11.826 15.4917 13.7012 15.037 15.0362 15.4542L31.9572 20.7419L35.5489 19.2082C35.9917 19.0191 36.5034 19.0977 36.869 19.411L38.4374 20.755Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3018 10.9893C55.144 12.8315 55.144 15.8183 53.3018 17.6606C53.2709 17.6915 53.2395 17.7219 53.2078 17.752L28.5579 41.0682L27.7656 41.8601L31.2332 53.6359L30.0946 54.7746C29.1089 55.7602 27.7896 55.5439 27.1585 54.3123L21.4648 43.1993C21.3989 43.1419 21.3345 43.0819 21.2718 43.0192C21.2094 42.9568 21.1497 42.8927 21.0925 42.8272L9.97875 37.1325C8.80069 36.5289 8.55151 35.2955 9.3947 34.3268L9.51646 34.1964L10.6551 33.0578L22.4301 36.5246L23.2489 35.7071L46.5391 11.0833C48.3293 9.19063 51.315 9.10753 53.2077 10.8978C53.2395 10.9278 53.2708 10.9583 53.3018 10.9893Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFlightTravel64);
export default __webpack_public_path__ + "static/media/pictogramBeaconFlightTravel64.a046ffa6ca30c36cdefe9c815b6c44d7.svg";
export { ForwardRef as ReactComponent };